/** Closed-select / option label: number, then description when the PO has one. */
export function formatPoOptionLabel(po: {
  poNumber: string;
  description?: string | null;
}): string {
  const description = po.description?.trim();
  return description ? `${po.poNumber} — ${description}` : po.poNumber;
}
